import type { ReactNode } from 'react'
import type { InterpolationFunction } from 'styled-components'
import styled from 'styled-components'

import user from 'legacy/utils/user'

import { getMagicLinkToken } from 'auth/use-cases/getMagicLinkToken'
import RateCommandCenterHeader from 'rate-command-center/ui/RateCommandCenterHeader'

import LoggedInNavigation from './LoggedInNavigation'
import LoggedOutNavigation from './LoggedOutNavigation'

interface PageWithSideNavProps {
  readonly children: ReactNode
  readonly color?: string
  readonly padding?: string | InterpolationFunction<any>
}

const Wrapper = styled.div`
  m-page-content > m-header {
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
  }
`

function ShipperGuideLayout({ children, color, padding }: PageWithSideNavProps) {
  const isUserLoggedIn = user.isLoggedIn()
  const isUserWithMagicLinkToken = Boolean(getMagicLinkToken())

  if (isUserLoggedIn) {
    return (
      <LoggedInNavigation color={color} padding={padding}>
        {children}
      </LoggedInNavigation>
    )
  }

  if (isUserWithMagicLinkToken) {
    return (
      <LoggedOutNavigation color={color} padding={padding}>
        {children}
      </LoggedOutNavigation>
    )
  }

  return (
    <>
      <RateCommandCenterHeader showAllInfo={false} />
      <Wrapper>{children}</Wrapper>
    </>
  )
}

export default ShipperGuideLayout
